import {useContext, useEffect, useState} from "react";
import HeaderPage from "../components/HeaderPage";
import {TouchableOpacity, View} from "react-native";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import FontAwesome from "../components/FontAwesome";
import {RowSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import {storageFunctions} from "../../../storage";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";

export default function UserMenu({navigation}: any) {

    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const appFunctions = useContext(AppFunctionsContext);

    const [phone, setPhone] = useState<string | null>("");

    useEffect(() => {
        storageFunctions.getData("user_phone_number").then((num: string | null) => {
            setPhone(num);
        });
    }, []);

    return <HeaderPage title={"حساب کاربری"} scrollableContent={true}>

        <Item icon={""} onPress={() => {
            appFunctions.appNavigator.toClientInfoEdit();
        }}>
            <Text size={14} weight={600} color={colors.get("highConText") as string}>کاربری من</Text>
            {phone != null ?
                <Text size={12} color={colors.get("lowConText") as string}>{`وارد شده با شماره: ${phone}`}</Text> :
                <Text size={12} color={colors.get("lowConText") as string}>وارد شده به عنوان مهمان</Text>}
        </Item>

        <Item icon={""} onPress={() => {
            appFunctions.appNavigator.toOrdersHistory();
        }}>
            <Text size={14} weight={600} color={colors.get("highConText") as string}>سفارش های من</Text>
        </Item>

        <Item icon={""} onPress={() => {
            appFunctions.appNavigator.toDeliveryAddresses();
        }}>
            <Text size={14} weight={600} color={colors.get("highConText") as string}>آدرس های من</Text>
        </Item>

    </HeaderPage>
}


function Item(props: { icon: string, children: any, onPress: () => void }) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <TouchableOpacity onPress={props.onPress}>
        <View>
            <View style={{paddingHorizontal: 20, flexDirection: "row", minHeight: 68, alignItems: "center"}}>
                <FontAwesome icon={props.icon} size={16} type={"solid"} color={colors.get('primaryColor') as string}/>
                <RowSpace w={30}/>
                <View>
                    {props.children}
                </View>
            </View>
            <View style={{height: 1, width: "100%", backgroundColor: colors.get("separator") as string}}/>
        </View>
    </TouchableOpacity>
}
